export enum PdpSections {
  MEDIA = "media",
  SUMMARY = "summary",
  FIND_MATCH = "find_a_match",
  PRODUCT_DETAILS = "product_details",
  SUPPLIER_DETAILS = "supplier_details",
  COMMENTS_SECTION = "inventory_comment",
  SUPPLIER_SECTION = "supplier",
  ACTION = "action",
  BUY_MEMO_HOLD_SECTION = "buymemohold",
  ASK_SUPPLIER = "ask_supplier",
  PDP_SHARE = "pdp_share",
  MATCH_PAIR_PRODUCT_DETAILS = "match_pair_product_details",
  CUSTOM_BMH = "custom_bmh",
  COMMENTS = "comments",
  PERSONALIZATION = "personalization",
  JEWELRY_CONFIGURATOR = "jewelry_configurator",
  JEWELRY_BUILDER = "jewelry_builder",
  QUANTITY_SELECTOR = "quantity_selector",
  PRICE_DISCLAIMER = "price_disclaimer",
  // Configurable PDP components
  FEATURE_BUTTONS = "feature_buttons",
  COMPONENTS_SECTION = "components_section",
  SUPPLIER_CONTAINER = "supplier_container",
  SUPPLIER_INFO = "supplier_info",
  SUPPLIER_COMMENT = "supplier_comment",
  PDP_SECTIONS_ORDER = "pdp_sections_order",
  MATCHING_BAND_DETAILS = "matching_band_details",
  REFUND_POLICY = "refund_policy",
}

// Component names for PDP section ordering
export enum PdpComponentNames {
  PRICE_DISCLAIMER = "price_disclaimer",
  FEATURE_BUTTONS = "feature_buttons",
  JEWELRY_CONFIGURATOR = "jewelry_configurator",
  PRODUCT_DETAILS = "product_details",
  PERSONALIZATION = "personalization",
  COMPONENTS_SECTION = "components_section",
  COMMENTS = "comments",
  SUPPLIER_CONTAINER = "supplier_container",
  SUPPLIER_INFO = "supplier_info",
  SUPPLIER_COMMENT = "supplier_comment",
  MATCHING_BAND_DETAILS = "matching_band_details",
  // Review page specific components
  STONE_CARD = "stone_card",
  MATCHING_STONE_CARD = "matching_stone_card",
  SETTING_CARD = "setting_card",
  // Match Pair specific components
  MATCH_HEADER = "match_header",
  MATCH_PRICE_DESCRIPTION = "match_price_description",
  MATCH_PRODUCT_DETAILS = "match_product_details",
  REFUND_POLICY = "refund_policy",
}

export interface SubSection {
  name: string;
  label: string;
  order: number;
}

export interface CustomtOption {
  label: string;
  name: string;
  icon: Icon;
  type: string;
  order: number;
  webOrder?: number;
  isSingleRow?: boolean;
  price_modes: number[];
  response_key: string;
  screen_width: string[];
  is_Engravable?: boolean;
  clickable?: boolean;
  color?: string;
  prefix_key?: string;
  extra_css?: {
    typography?: string;
    textDecoration?: string;
  };
}

export interface SectionLayout {
  options?: CustomtOption[];
  "sub-sections"?: CustomtOption[];
  sub_section?: CustomtOption[];
  variation_padding?: number;
  price_modes?: number[];
  icon?: Icon;
  description?: string;
}

export interface Shadow {
  x: number;
  y: number;
  blur: number;
  spread: number;
  color: string;
}

export interface Shadows {
  Normal: Shadow;
  Gentle: Shadow;
  Huge: Shadow;
  "Bottom-scroll": Shadow;
}

export interface Icon {
  data: string;
  type: string;
  color: string;
}
